module.exports = __webpack_public_path__ + "img/produksi-grafika-major.c97cd98b.png";